// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Kg8ywQEy","disabled":"w3cTWRA4"};